import { createContext, useContext } from 'react';

const context = createContext({});

export const usePersonaTypeContext = () => useContext(context);

export default context;
